
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInternet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.432 11.892a10.08 10.08 0 0 1 13.042 0M2.9 7.813c5.332-4.024 12.775-4.024 18.107 0a.673.673 0 0 1 .1.975L12.462 18.98a.668.668 0 0 1-1.02-.006L2.8 8.792a.677.677 0 0 1 .099-.979z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M12.462 18.98a.665.665 0 0 1-1.02-.006l-6.008-7.082a10.08 10.08 0 0 1 13.041 0l-6.013 7.088z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"72\" height=\"72\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M5.432 11.892a10.08 10.08 0 0 1 13.042 0M2.9 7.813c5.332-4.024 12.775-4.024 18.107 0a.673.673 0 0 1 .1.975L12.462 18.98a.668.668 0 0 1-1.02-.006L2.8 8.792a.677.677 0 0 1 .099-.979z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\"/>\r\n    <path opacity=\".3\" d=\"M12.462 18.98a.665.665 0 0 1-1.02-.006l-6.008-7.082a10.08 10.08 0 0 1 13.041 0l-6.013 7.088z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/internet.b0e7c994fe132a95ff3d79b8d4c450dc.svg"),
        {
          React: SvgInternet,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      